<div class="c-page">
  <header>
    <h1 class="-blue">Gerenciador de Monitoramento dos Diretórios
      <app-tooltip-info texto="Após o download, para o adequado funcionamento da plataforma é necessário instalar o programa 'Gerenciador de Monitoramento de Diretórios'
        no mesmo servidor/computador que o seu sistema contábil realiza a extração das obrigações SPED das empresas e informar os diretórios, que passarão a ser monitorados
        para início automático das automações quando identificado arquivo SPED.">
      </app-tooltip-info>
    </h1>
    <p class="-gray">Nessa etapa você fará download e a configuração do aplicativo que gerenciará os diretórios em que
      você gera as obrigações do SPED de suas empresas</p>
  </header>
  <section class="section">
    <div class="button-container">
      <!-- Descomentar após implementar a feature -->
      <!-- <button class="o-button -blue" routerLink="../manual">Manual de Instruções</button>
      <button class="o-button -blue" routerLink="../faq">Perguntas Frequêntes</button> -->
    </div>
    <div class="slider">
      <div class="slide"><img src="assets/images/uploader-screens/uploader-startup.png" /></div>
      <div class="slide"><img src="assets/images/uploader-screens/uploader-login.png" /></div>
      <div class="slide"><img src="assets/images/uploader-screens/uploader-profile.png" /></div>
    </div>

    <div class="action-container">
        <button class="o-button -white" type="button" (click)="baixarManual()">Manual do programa</button>
        <button class="o-button -blue" type="button" (click)="baixarUploader()">Download</button>
    </div>

    <div class="button-container -flexCenter flex-content-center">
      <p class="posicao-text-versao" *ngIf="ultimaVersao">Versão disponível: {{ultimaVersao}}</p>
    </div>

    <div class="button-container -flexEnd" style="justify-content: center;">

      <footer class="inner-footer" style="width: 22%">
        <app-step-navigator (whenPrevious)="goToPreviousStep()" (whenCancel)="returnDashboard()" [hideRightButton]="true" [flexPosition]="'left'">
        </app-step-navigator>
      </footer>

      <button class="o-button -blue btn-concluir" type="button" (click)="submit()" [class.btn-ir-dashboard]="processoCadastralConcluido"
        *ngIf="contratante">{{processoCadastralConcluido ? 'Ir ao Dashboard' : 'Concluir' }}</button>
    </div>
  </section>
</div>
